import React from 'react';
import {Table, Button, Input, Modal} from 'antd';

class Map extends React.Component {
    constructor(props) {
        super();
    }

    state = {
        visible:false
    }

    point = {};

    componentDidMount() {
        window.addEventListener('message', this.postMessage, false);
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.postMessage);
    }

    postMessage = (event)=>{
        var loc = event.data;
        if (loc && loc.module == 'locationPicker') {
            this.point = loc.latlng;
        }
    }

    submitHandler = ()=>{
        let {onChange} = this.props;
        var target = this.point;
        if(target.lat && target.lng) {
            this.setState({
                visible:false
            }, ()=>{
                onChange(target);
            });
        }else {
            Modal.warning({
                title:'提示',
                content:'请先选择地点信息，或点击取消关闭地图'
            });
        }
    }

    render() {
        let {value} = this.props;

        value = typeof value == 'object' ? value : {};

        var coord = value.lat && value.lng ? `${value.lat},${value.lng}` : "";
        var url = "";
        if(this.state.visible) {
            if(0 && coord) {
                url = "https://3gimg.qq.com/lightmap/components/locationPicker2/index.html?coord="+coord+"&coordtype=5&search=1&type=1&key=6YPBZ-DKRAW-F5ARW-OBCRX-6O6IV-33FOX&referer=jfoto.cn";
            }else {
                url = "https://3gimg.qq.com/lightmap/components/locationPicker2/index.html?search=1&type=1&key=6YPBZ-DKRAW-F5ARW-OBCRX-6O6IV-33FOX&referer=jfoto.cn";
            }
        }else {
            url = "about:blank";
        }

        return <div className="map">
            <span>纬度：{value.lat || "暂无"} 经度：{value.lng || "暂无"} &nbsp;</span>
            <Button onClick={()=>this.setState({visible:true})}>选择</Button>

            <Modal visible={this.state.visible} onOk={this.submitHandler} onCancel={()=>this.setState({visible:false})} title="请选择地点">
                <div style={{margin:"0 auto", width:488}}>
                    <iframe id="mapPage" width={488} height={440} frameBorder={0} title={'map'}
                        src={url}>
                    </iframe>
                </div>
            </Modal>
        </div>;
    }
}

export default Map;



// WEBPACK FOOTER //
// ./src/components/Select/Map.js